export default __webpack_public_path__ + "static/media/a001-06.927391f3.svg";